/*! bluetti v2.0.0 | (c) 2022 Bluettipower | MIT License | https://gitee.com/bluetti/shopify-gulp.git */

(() => {
  class e extends HTMLElement {
    constructor() {
      super(), this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((e, t) => e + parseInt(t.value), 0), this.debouncedOnChange = Shopify.debounce(e => {
          this.onChange(e)
        }, 300), this.addEventListener("change", this.debouncedOnChange.bind(this)), window.state.isProductPage && (UIkit.util.query("header-cart-dropdown")
          .addEventListener("show", this.refreshAffirm), UIkit.util.query("header-cart-dropdown")
            .addEventListener("hide", this.refreshAffirm)),
        this.accessoryRecommendationAdd();
      this.cartOffcanvas = document.querySelector("header-cart-dropdown");
    }
    refreshAffirm () {
      var e = this.closest("[data-total-price]")
        .dataset;
      e && document.querySelector('[data-page-type="cart"]')
        ?.setAttribute("data-amount", e.totalPrice);
      try {
        affirm.ui.refresh()
      } catch (e) {
        console.error(e)
      }
    }
    onChange (e) {
      this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.getAttribute("name"))
    }
    getSectionsToRender () {
      return [{
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents"
      }, {
        id: "cart-icon-bubble",
        section: "cart-badge",
        selector: ".tm-cart-badge"
      }]
    }
    updateQuantity (t, e, r) {
      this.enableLoading(t);
      e = JSON.stringify({
        line: t,
        quantity: e,
        sections: this.getSectionsToRender()
          .map(e => e.section),
        sections_url: window.location.pathname
      });
      fetch("" + routes.cart_change_url, {
        ...Shopify.fetchConfig(),
        body: e
      })
        .then(e => e.text())
        .then(e => {
          e = JSON.parse(e);
          this.renderContents(e), this.updateLiveRegions(t, e.item_count), this.disableLoading();
          try {
            affirm.ui.refresh()
          } catch (e) {
            console.error(e)
          }
        })
        .catch(e => {
          console.error(e), document.querySelector("cart-error-message.uk-alert")
            .show(), document.querySelector("cart-error-message.uk-alert")
              .setContent(window.cartStrings.error), this.disableLoading()
        })
    }
    renderContents (t) {
      this.getSectionsToRender()
        .forEach(e => {
          (document.getElementById(e.id)
            .querySelector(e.selector) || document.getElementById(e.id))
            .innerHTML = this.getSectionInnerHTML(t.sections[e.section], e.selector)
        })
      // 更新购物车后再声明一次事件
      this.accessoryRecommendationAdd();

      if(document.querySelector(".cart-recommend-box-content")){
        const ps = new PerfectScrollbar('.cart-recommend-box-content', {
          wheelSpeed: 2,
          wheelPropagation: true,
          minScrollbarLength: 20
        });
    
        ps.update();
      }  
      
    }
    updateLiveRegions (e, t) {
      if (this.currentItemCount === t) {
        const t = document.getElementById("Line-item-error-" + e);
        if(!t) return;
        t.show(), t.setContent(window.cartStrings.quantityError.replace("[quantity]", document.getElementById("Quantity-" + e)
          .value))
      }
      this.currentItemCount = t
    }
    getSectionInnerHTML (e, t) {
      return (new DOMParser)
        .parseFromString(e, "text/html")
        .querySelector(t)
        .innerHTML
    }
    enableLoading (e) {
      this.querySelectorAll("loading-animation")[e - 1].show(), document.activeElement.blur()
    }
    disableLoading () {
      this.querySelectorAll("loading-animation")
        .forEach(e => e.hide())
    }
    async getCartData () {
      var t = JSON.stringify({
        sections: this.cartOffcanvas.getSectionsToRender().map(t => t.section),
        sections_url: window.location.pathname
      });
      return fetch("" + routes.cart_update_url, {
        ...Shopify.fetchConfig(),
        body: t
      }).then(t => t.text()).then(t => JSON.parse(t))
    }
    handleErrorMessage (t = !1) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector("[data-error-message-wrapper]") || null,
        this.errorMessageWrapper && (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector("[data-error-message]") || null,
          this.errorMessageWrapper && this.errorMessageWrapper.toggleAttribute("hidden", !t),
          t && this.errorMessage && (this.errorMessage.textContent = t))
    }

    accessoryRecommendationAdd () {
      var allBtn = this.querySelectorAll(".cart-accessory-recommendation-btn");
      var cartRecommendBoxLoading = document.querySelector(".cart-recommend-box-loading");
      allBtn.forEach(btn => {
        btn.addEventListener('click', (event) => {
          cartRecommendBoxLoading.show()

          // 获取变体 ID
          var variantId = btn.getAttribute("data-id");
          // console.log('variantId', variantId);
          // 创建一个加入购物车的请求
          var addToCartRequest = {
            items: [
              {
                id: variantId,
                quantity: 1
              }
            ]
          };

          // 发送请求并将产品添加到购物车
          fetch(routes.cart_add_url + ".js", {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(addToCartRequest)
          }).then(t => t.json()).then(async t => {
            if (t.status)
              this.handleErrorMessage(t.description);
            else {
              var e = await this.getCartData();
              this.cartOffcanvas.renderContents(e);
            }
          }
          ).catch(t => {
            UIkit.offcanvas(this.cartOffcanvas).hide()
          }
          ).finally(() => {
            cartRecommendBoxLoading.hide()
          }
          )
        }, false)
      })


      // 配件-鼠标按住左右移动滚动条 start
      // var cartRecommendBoxContent = document.querySelector('.cart-recommend-box-content');
      // if (!cartRecommendBoxContent) return;
      // var isMouseDownCart = false;
      // var startXCart;
      // var scrollLeftCart;
      // cartRecommendBoxContent.addEventListener('mousedown', function (e) {
      //   isMouseDownCart = true;
      //   startXCart = e.pageX - cartRecommendBoxContent.offsetLeft;
      //   scrollLeftCart = cartRecommendBoxContent.scrollLeft;
      // });

      // cartRecommendBoxContent.addEventListener('mouseleave', function () {
      //   isMouseDownCart = false;
      // });

      // cartRecommendBoxContent.addEventListener('mouseup', function () {
      //   isMouseDownCart = false;
      // });

      // cartRecommendBoxContent.addEventListener('mousemove', function (e) {
      //   if (!isMouseDownCart) return;
      //   e.preventDefault();
      //   var x = e.pageX - cartRecommendBoxContent.offsetLeft;
      //   var walk = (x - startXCart) * 2; // 控制滚动条移动距离的倍数
      //   cartRecommendBoxContent.scrollLeft = scrollLeftCart - walk;
      // });

      // 配件-鼠标左右移动 start
      // 鼠标移动
      /**
      let cartRecommendBoxContent = document.querySelector('.cart-recommend-box-content');
      if (!cartRecommendBoxContent) return;
      let accessoriesRecommendationBoxA = cartRecommendBoxContent?.querySelectorAll('a')
      let isMouseDown = false;
      let startX = 0;
      let startTranslateX = 0;
      let currentTranslateX = 0;
      let minTranslateX = 0;
      let maxTranslateX = 0;
      let resistance = 0.2;

      accessoriesRecommendationBoxA?.forEach(item => {
        item.addEventListener('dragstart', function (e) {
          if (e.target.tagName === 'A') {
            e.preventDefault();
          }
        });
        item.addEventListener('mouseup', function (e) {
          if (e.target.tagName === 'A') {
            e.preventDefault();
          }
        });
        // item.addEventListener('click', function (e) {
        //   if (e.target.tagName === 'A') {
        //     e.preventDefault();
        //   }
        // });
      })

      function handleTouchStart (e) {
        e.stopPropagation();

        startX = e.clientX;
        startTranslateX = getCurrentTranslateX(cartRecommendBoxContent.style.transform);
        currentTranslateX = startTranslateX;
        minTranslateX = cartRecommendBoxContent.parentElement.offsetWidth - getTotalChildWidth(cartRecommendBoxContent);
        minTranslateX > 0 ? isMouseDown = false : isMouseDown = true;
        maxTranslateX = 0;

        // 按下时移除过渡效果
        cartRecommendBoxContent.style.transition = 'none';
      }


      function handleTouchMove (e) {
        e.stopPropagation();
        if (!isMouseDown) return;

        let moveX = e.clientX - startX;
        let newTranslateX = startTranslateX + moveX;
        // 添加反弹效果
        if (newTranslateX > 80) {
          newTranslateX = 80 + (newTranslateX - 80) * resistance;
        } else if (newTranslateX < minTranslateX - 80) {
          newTranslateX = minTranslateX - 80 + (newTranslateX - (minTranslateX - 80)) * resistance;
        }

        // 更新 transform: translateX
        cartRecommendBoxContent.style.transform = `translateX(${newTranslateX}px)`;
        currentTranslateX = newTranslateX;
        return false
      }

      function handleTouchEnd (e) {
        e.stopPropagation();
        isMouseDown = false;

        // 松开时添加过渡效果
        cartRecommendBoxContent.style.transition = 'transform 0.3s ease';

        // // 判断移动方向并修正位置
        let diffTranslateX = currentTranslateX - startTranslateX;
        if (diffTranslateX > 0) {
          cartRecommendBoxContent.style.transform = `translateX(${maxTranslateX}px)`;
        } else if (diffTranslateX < 0 && currentTranslateX <= minTranslateX) {
          cartRecommendBoxContent.style.transform = `translateX(${minTranslateX}px)`;
        } else {
          cartRecommendBoxContent.style.transform = `translateX(${currentTranslateX}px)`;
        }
        // if (startTranslateX === currentTranslateX && e.target.tagName === "A") {
        //   e.preventDefault();
        //   console.log(startTranslateX, currentTranslateX);
        // }
        return false
      }

      // 鼠标按下事件
      cartRecommendBoxContent.addEventListener('mousedown', handleTouchStart);
      // 鼠标移动事件
      document.addEventListener('mousemove', handleTouchMove);
      // 鼠标松开事件
      document.addEventListener('mouseup', handleTouchEnd);

      // cartRecommendBoxContent.addEventListener('touchstart', handleTouchStart);
      // cartRecommendBoxContent.addEventListener('touchmove', handleTouchMove);
      // cartRecommendBoxContent.addEventListener('touchend', handleTouchEnd);

      // 从 transform: translateX 中提取当前的 translateX 值
      function getCurrentTranslateX (transformValue) {
        let match = transformValue.match(/translateX\(([-\d]+)px\)/);
        return match && match.length === 2 ? parseFloat(match[1]) : 0;
      }

      // 获取 cart-recommend-box-content 类全部子元素的宽度合
      function getTotalChildWidth (element) {
        let totalWidth = 0;
        let childNodes = element.childNodes;

        for (let i = 0; i < childNodes.length; i++) {
          if (childNodes[i].nodeType === Node.ELEMENT_NODE) {
            totalWidth += childNodes[i].offsetWidth;
          }
        }

        return totalWidth;
      }

      // 配件-鼠标左右移动 end
       */
    }
  }
  customElements.define("cart-items", e);
  class t extends HTMLElement {
    constructor() {
      super()
    }
    show () {
      this.classList.remove("uk-hidden")
    }
    hide () {
      this.classList.add("uk-hidden")
    }
    setContent (e) {
      this.querySelector("[data-message]")
        .innerHTML = e, this.setTimeOutHide()
    }
    setTimeOutHide (e = 4e3) {
      const t = setTimeout(() => {
        this.hide(), clearTimeout(t)
      }, e)
    }
  }
  customElements.define("cart-error-message", t);
  class r extends HTMLElement {
    constructor() {
      super(), this.addEventListener("click", e => {
        e.preventDefault(), this.closest(e.target.dataset.name)
          .updateQuantity(this.dataset.index, 0)
      })
    }
  }
  customElements.define("cart-remove-button", r), customElements.define("header-cart-dropdown", class extends e {
    constructor() {
      super()
    }
    getSectionsToRender () {
      return [{
        id: "cart-offcanvas-nav",
        section: "global-cart-dropdown",
        selector: "header-cart-dropdown"
      }, {
        id: "cart-icon-bubble",
        section: "cart-badge",
        selector: ".tm-cart-badge"
      }]
    }
  })
})();
